<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/establish/contractlist',title:'返利管理'},{title:'客户返利报表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content w-content">

            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="经销商编码/名称" prop="agentNameLike">
							    <el-input v-model="q.agentNameLike" placeholder="请输入"></el-input>
							</el-form-item>
                            <el-form-item label="经销商类型" prop="agentType">
                                <brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
                            </el-form-item>
							<el-form-item class="nianboxs" label="时间" prop="month" v-if="check1">
							    <el-date-picker
									style="width: 100%;"
							            v-model="q.date"
							            :clearable="true"
							            type="month"
							            value-format="yyyy-MM"
							            placeholder="选择日期">
							    </el-date-picker>
							</el-form-item>
                            <el-form-item label="导出类型" prop="type">
                                <el-select v-model="q.type" placeholder="请选择">
                                    <el-option
                                            v-for="item in fljsstyle"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
							<el-form-item class="right-btn">
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
							</el-form-item>
						</div>
                    </el-form>
                </div>
            </div>



            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table @selection-change="handleSelectionChange"
                          ref="ddtable"
                          :data="tableData"
                          stripe
                          style="width: 100%"
                          :summary-method="getSummaries"
                          :border="true"
                          show-summary
						  max-height="530"


                >
                    <!-- <el-table-column
                            type="selection"
                            width="65"
                    >
                    </el-table-column>
                    <el-table-column
                            type="index"
                            label="#"
                            fixed
                            width="40">
                    </el-table-column> -->

                    <el-table-column
                            prop="agentCode"
                            :show-overflow-tooltip="true"
                            label="经销商编码"
                            width="110"
                            fixed
                    >
                    </el-table-column>

                    <el-table-column
                            prop="agentName"
                            :show-overflow-tooltip="true"
                            label="经销商名称"
                            min-width="180"
                            fixed
                    >
                        <template slot-scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.agentName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="agentType"
                            label="经销商类型"
                            :show-overflow-tooltip="true"
                            width="100">
                        <template slot-scope="scope">
                            {{scope.row.agentType|dictname('fl_agent_type')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="areaname"
                            :show-overflow-tooltip="true"
                            label="区域"
                            width="80"
                    >
                        <template slot-scope="scope">
                            {{scope.row.area|dictname('YLRegion')}}
                        </template>
                    </el-table-column>
                    <el-table-column label="合计" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="zljjs"
                                :show-overflow-tooltip="true"
                                label="累计计算"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.zljjs).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zljdx"
                                :show-overflow-tooltip="true"
                                label="累计兑现"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.zljdx).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="zydwd"
                                :show-overflow-tooltip="true"
                                label="应兑未兑"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.zydwd).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="传统产品" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="ctljjs"
                                :show-overflow-tooltip="true"
                                label="累计计算"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.ctljjs).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="ctljdx"
                                :show-overflow-tooltip="true"
                                label="累计兑现"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.ctljdx).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="ctydwd"
                                :show-overflow-tooltip="true"
                                label="应兑未兑"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.ctydwd).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="U疫苗" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="ymljjs"
                                :show-overflow-tooltip="true"
                                label="累计计算"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.ymljjs).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="ymljdx"
                                :show-overflow-tooltip="true"
                                label="累计兑现"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.ymljdx).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="ymydwd"
                                :show-overflow-tooltip="true"
                                label="应兑未兑"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.ymydwd).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="U血液" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="xyljjs"
                                :show-overflow-tooltip="true"
                                label="累计计算"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.xyljjs).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="xyljdx"
                                :show-overflow-tooltip="true"
                                label="累计兑现"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.xyljdx).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="xyydwd"
                                :show-overflow-tooltip="true"
                                label="应兑未兑"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.xyydwd).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="U试剂" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="sjljjs"
                                :show-overflow-tooltip="true"
                                label="累计计算"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.sjljjs).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="sjljdx"
                                :show-overflow-tooltip="true"
                                label="累计兑现"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.sjljdx).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="sjydwd"
                                :show-overflow-tooltip="true"
                                label="应兑未兑"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: right;">{{Number(scope.row.sjydwd).toFixed(2)}}</div>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel" v-auth="'khflbb_daochu'">批量导出
                        </el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'

    export default {
        components: {},
        data() {
            return {
                fljsstyle: [
                    {
                        value: 1,
                        label: '月度'
                    },
                    {
                        value: 2,
                        label: '年度'
                    },
                ],
                check1:true,
                value2:'',
                showhistory:false,
                instid: '',
                taskid:'',
                //查询属性
                page:{
                    contractBaseId:'',
                    pageSize:20,
                    pageNo:1
                },
                q: {
                    taskid:'',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f:{
                    pageNo:1,
                    id:null, //
                    agentName:null, //
                    agentCode:null, //
                    area:null,
                    ymljjs:null,
                    ymljdx:null, //
                    ymydwd:null, //
                    xyljjs:null, //
                    xyljdx:null,
                    xyydwd:null,
                    sjljjs:null, //
                    sjljdx:null, //
                    sjydwd:null, //
                    ctljjs:null,
                    ctljdx:null,
                    ctydwd:null, //
                    zljjs:null, //
                    zljdx:null, //
                    zydwd:null,


                },
                //表格
                multipleSelection: [],

                //table列表
                tableData: [],
                flag:0,
                //操作标志
                optflag:'save',
                countlist:[]
            }
        },
        created() {
            this.q = {
                taskid:'',
                pageSize: 10,
                pageNo: 1,
                total: 0,
                date: this.doHandleDate(),
                type:1,
            }
            this.query();
            this.querya();
        },
        methods: {


            //重置
            qingkong(){
                this.q={
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                }

                this.query();
				this.querya();
                // this.q.date = this.doHandleDate();
            },
            dateChange1(val) {
                val = val.replace(/-/g, '/')
                var date = new Date(val);
                this.day1 = date.getTime();
                if (this.day2 < this.day1) {
                    if (this.day2 == 0) {
                        return;
                    }
                    this.$msg.msge("结束日期不能在开始日期之前");
                    this.formInline.enddate = "";
                }
            },
            dateChange2(val) {
                val = val.replace(/-/g, '/')
                var date = new Date(val);
                this.day2 = date.getTime()
                if (this.day2 < this.day1) {
                    this.$msg.msge("结束日期不能在开始日期之前");
                    this.formInline.enddate = "";
                }
            },
            query() {
                ss.fanli.pagefanliTable(this.q).then(rd=>{
                    console.log(rd,"BBBBBB");
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                });

            },
            querya() {
                ss.fanli.getFanliTableZongji(this.q).then(rd=>{
                    console.log(rd,"AAAABBBBBB");
                    this.countlist = rd.records;
                });

            },
            getSummaries(param){
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    console.log(column,index)
                    if (index === 0) {
                        sums[index] = '总计';
                        console.log(index+"@@@@@@")
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);

                        // sums[5] = Number(this.countlist[0].zzljjs).toFixed(2);
                        // sums[6] = Number(this.countlist[0].zzljdx).toFixed(2);
                        // sums[7] = Number(this.countlist[0].zzydwd).toFixed(2);
                        // sums[8] = Number(this.countlist[0].zctljjs).toFixed(2);
                        // sums[9] = Number(this.countlist[0].zctljdx).toFixed(2);
                        // sums[10] = Number(this.countlist[0].zctydwd).toFixed(2);
                        // sums[11] = Number(this.countlist[0].zymljjs).toFixed(2);
                        // sums[12] = Number(this.countlist[0].zymljdx).toFixed(2);
                        // sums[13] = Number(this.countlist[0].zymydwd).toFixed(2);
                        // sums[14] = Number(this.countlist[0].zxyljjs).toFixed(2);
                        // sums[15] = Number(this.countlist[0].zxyljdx).toFixed(2);
                        // sums[16] = Number(this.countlist[0].zxyydwd).toFixed(2);
                        // sums[17] = Number(this.countlist[0].zsjljjs).toFixed(2);
                        // sums[18] = Number(this.countlist[0].zsjljdx).toFixed(2);
                        // sums[19] = Number(this.countlist[0].zsjydwd).toFixed(2);

						sums[3] = Number(this.countlist[0].zzljjs).toFixed(2);
						sums[4] = Number(this.countlist[0].zzljdx).toFixed(2);
						sums[5] = Number(this.countlist[0].zzydwd).toFixed(2);
						sums[6] = Number(this.countlist[0].zctljjs).toFixed(2);
						sums[7] = Number(this.countlist[0].zctljdx).toFixed(2);
						sums[8] = Number(this.countlist[0].zctydwd).toFixed(2);
						sums[9] = Number(this.countlist[0].zymljjs).toFixed(2);
						sums[10] = Number(this.countlist[0].zymljdx).toFixed(2);
						sums[11] = Number(this.countlist[0].zymydwd).toFixed(2);
						sums[12] = Number(this.countlist[0].zxyljjs).toFixed(2);
						sums[13] = Number(this.countlist[0].zxyljdx).toFixed(2);
						sums[14] = Number(this.countlist[0].zxyydwd).toFixed(2);
						sums[15] = Number(this.countlist[0].zsjljjs).toFixed(2);
						sums[16] = Number(this.countlist[0].zsjljdx).toFixed(2);
						sums[17] = Number(this.countlist[0].zsjydwd).toFixed(2);
                    } else {
                        sums[1] = '';
                        sums[2] = '';
                        // sums[3] = '';
                        // sums[4] = '';
                    }
                });

                return sums;
            },
            handleFilter() {
                console.log("QQQQQ")
                this.query();
                this.querya()
            },
            doHandleDate() {
                var myDate = new Date();
                var tYear = myDate.getFullYear();
                var tMonth = myDate.getMonth();

                var m = tMonth + 1;
                if (m.toString().length == 1) {
                    m = "0" + m;
                }
                return tYear +'-'+ m;
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log(this.multipleSelection,"WWWWWWWWWW")
            },
            //批量导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.agentName+","+this.q.date);
                });

                if (idlist.length != 0) {
                    // console.log(idlist);
                    updownfile.down("/api/swyl/v1/fanli/hetong/flContractAgent/downcustomerfanliExcel", idlist, "post", 'data');

                } else {
                    updownfile.down("/api/swyl/v1/fanli/hetong/flContractAgent/downloadExcelEntity", this.q, "post");
                }
                console.log(idlist,"AAAAAQQqq")
            },
        }
    }
</script>
<style lang="scss">
    .el-table thead.is-group th{
        background-color: #57aefe;
    }
	.w-content .el-table__footer-wrapper .cell {
		text-align: right;
	}
	.w-content .el-table__fixed-footer-wrapper tbody td {
		background: #cce7ff;
	}
	.w-content .el-table__footer-wrapper tbody td {
		background: #cce7ff;
	}
	.el-table--scrollable-x .el-table__body-wrapper {
	    z-index : 1;
	}
	.el-table__fixed, .el-table__fixed-right {
	    box-shadow: none;
	}
	.el-table__fixed, .el-table__fixed-right {
	      &::after{
	         position:absolute;
	         top:0;
	         right:0;
	         bottom:0;
	         content:'';
	         z-index:100;
	         box-shadow: 0 0 10px rgba(0,0,0,.12);
	      }
	    }
	.el-table__fixed-footer-wrapper tbody td{
		border-top: 0;
	}
</style>
